import { ChatModalComponent } from "./../modals/chat-modal/chat-modal.component";
import { AuthenticationService } from "./../authentication.service";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
} from "@angular/core";
import { DataService } from "../data.service";
import { EventsService } from "angular4-events";
import { format } from "libphonenumber-js";
import { CountryService } from "../country.service";
import { Constants } from "../constants";
import { Subscription } from "rxjs/Subscription";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

declare var $: any;
declare var toastr: any;
declare var Nanobar: any;
declare var google: any;
declare var require: any;

@Component({
  selector: "app-custom-order",
  templateUrl: "./custom-order.component.html",
  styleUrls: ["./custom-order.component.css"],
})
export class CustomOrderComponent implements OnInit, AfterViewInit {
  priceIconForSingle = Constants.iconForSinglePrice;
  priceIconForDouble = Constants.iconForDoublePrice;
  myDatePickerOptions: any;
  nao = new Nanobar();
  orderDetail: any;
  orderDetailByPage: any;
  // searchOrderString: any;
  searchTimeOut: any;
  outletDayindex = -1;
  outletDayname = "All";
  imageForPopup = new Array();
  statuschanger: any;
  textId: any;
  textIdIndex: any;
  changeStatus: any;
  searchOrderString = "";
  paginationPage = 0;
  limit = 25;
  lastPage: any;
  orderTextCount: any;
  rejectionText = "";
  contactText = "";
  messagesDetail: any;
  idval: any;
  customOrderId: any = "";
  phone_number: any;
  orderTextId: any;
  orderDetailToReopenOpId: any;
  orderDetailData: Object;
  customerDetail: any;
  droppOffAddress: any;
  userDropDocs: any;
  orderDataDisplay: any;
  pickupAddress: any;
  productData: any;
  thirdPartyData: any;
  returnOrderItems: any;
  onDetailDriverData: any;
  returnOrderItemsLength: any;
  deliverStartDate: Date;
  deliverEndDate: Date;
  cityName = "All";
  cityIndex: any = -1;
  clearTimeoutCustomer: any;
  searchStringCustomer: any;
  customerData: any;
  customerDataLength: any;
  dispensary_id: any;
  customerDisplayDataArray = new Array();
  selectedCustomerId: any;
  selectedCustomerObj: any;
  freeCount = 0;
  customerAddressList = [];
  numChk = false;
  customerMatch = false;
  first_name: any;
  last_name: any;
  number: any;
  email: any;
  is_tax_exempt = false;
  accept_marketing = false;
  note: any;
  findCustomerData: any;
  address_line1: any;
  address_line2: any;
  street: any;
  city: any;
  state: any;
  zip: any;
  area: any;
  apart: any;
  selectAddress = false;
  dob: any;
  selDate: any;
  latitude: any;
  longitude: any;
  purchased_amount: any;
  countryCode: any;
  placeDataFound = false;
  placeSuggestionsData: any;
  clearTimeout: any;
  houseNo: any;
  addressLoad = false;
  placeDetailData: any;
  place: any;
  error_count: any;
  addingCustomer = false;
  btnDisable = false;
  success: any;
  restErrorCode: any;
  orderRequestAddress: any;
  orderRequestCity = "";
  orderRequestPlatform = "";
  orderText: any = "";
  dropzone: any;
  customProductImages = new Array();
  orderbtn = false;
  customOrderImageSuccess: any;
  searchBusiness: any;
  showSearchResults: boolean = false;
  searchBusinessDetailforOrder: any;
  businessForOrders = "Business";
  customProductImagesCount = 0;
  customOrderImageSuccessUrl = new Array();
  businessIdForOrders: any;
  gender: any = -1;
  orderCreated: any;
  orderBooked: any;
  maxYear: any;
  phoneCode: any;
  purchase_amount: any = "";
  orderPunched: boolean = false;
  conversationId: any;
  textMessage: string = "";
  imageMessage: File;
  imageMessageBase64: string | ArrayBuffer = "";
  clientProfile: {
    order_id: string;
    name: string;
    phone_number: string;
    profile_image: string;
  } = {
    order_id: "",
    name: "",
    phone_number: "",
    profile_image: "",
  };
  messageData: any;
  messageListing: any[] = [];
  adminName: string = "";
  checkPopupOpenFlag: boolean = true;
  constructor(
    private dataService: DataService,
    private events: EventsService,
    private cs: CountryService,
    private authService: AuthenticationService,
    private cdRef: ChangeDetectorRef,
    public modalService: NgbModal
  ) {
    this.idval = this.events
      .subscribe("customerDetailUpdateDone")
      .subscribe((data) => {
        debugger
        if (data.page === "customerLis") {
          console.log("data", data);
          $(".customOrderCustomerDetail").css("display", "none");
          $(".customOrder").css("display", "block");
          // setTimeout(() => {
          $("html").scrollTop(data.scroll);
          // },100);
        }
        // $('.intl-tel-input').remove();
      });
  }

  orderTextDetailListing() {
    clearTimeout(this.searchTimeOut);
    // this.searchTimeOut = setTimeout(() => {
    this.dataService
      .orderDetailListing(
        window.localStorage.getItem("token"),
        this.searchOrderString,
        this.outletDayindex,
        this.cityIndex,
        this.paginationPage,
        this.limit
      )
      .subscribe(
        (data) => {
          //last_page
          this.orderDetail = data;
          window.localStorage.setItem(
            "pendingRequests",
            this.orderDetail.order_text_count
          );
          this.lastPage = this.orderDetail.last_page;
          this.orderDetail = this.orderDetail.items;
        },
        (error) => {
          toastr.error("Some thing went wrong");
        }
      );
    // }, 1000);
  }

  orderTextDetailListingByPage() {
    this.orderDetailByPage = [];
    this.paginationPage++;
    console.log("this.paginationPage", this.paginationPage);
    this.dataService
      .orderDetailListing(
        window.localStorage.getItem("token"),
        this.searchOrderString,
        this.outletDayindex,
        this.cityIndex,
        this.paginationPage,
        this.limit
      )
      .subscribe(
        (data) => {
          this.orderDetailByPage = data;
          this.lastPage = this.orderDetailByPage.last_page;
          this.orderDetailByPage = this.orderDetailByPage.items;
          for (var i = 0; i < this.orderDetailByPage.length; i++) {
            this.orderDetail.push(this.orderDetailByPage[i]);
          }
        },
        (error) => {
          // this.nao.go(100);
          console.log("error", error);
          toastr.error("Some thing went wrong");
        }
      );
  }
  statusChangeFunc(status, id, index, phone_number) {
    this.rejectionText = "";
    this.contactText = "";
    this.statuschanger = status;
    this.textId = id;
    this.textIdIndex = index;
    this.phone_number = phone_number;
    $("#statusChangeConformation").modal("show");
  }
  callStatusChangeFun() {
    console.log(this.customOrderId);
    if (this.statuschanger === 2 && this.rejectionText === "") {
      toastr.error("please add detail");
      return;
    }

    this.nao.go(30);
    this.dataService
      .order_text_detail_listing(
        window.localStorage.getItem("token"),
        this.statuschanger,
        this.textId,
        this.rejectionText,
        this.customOrderId,
        this.phone_number,
        this.purchase_amount
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.changeStatus = data;
          this.orderTextCount = this.changeStatus.order_text_count;
          this.orderTextId = this.changeStatus.order_id;
          console.log("this.orderTextCount", this.orderTextCount);
          this.changeStatus = this.changeStatus.success;
          if (this.changeStatus === true) {
            window.localStorage.setItem("pendingRequests", this.orderTextCount);
            this.orderTextDetailListing();
            this.orderDetail[this.textIdIndex].order_text_status =
              this.statuschanger;
            if (this.statuschanger === 1) {
              toastr.success("Order request has been completed");
            }
            if (this.statuschanger === 2) {
              toastr.success("Order request has been canceled");
            }
            $("#statusChangeConformation").modal("hide");
            $("#rejection").modal("hide");
          }
          if (this.changeStatus === false) {
            toastr.error(data["message"]);
          }
          this.customOrderId = "";
          this.purchase_amount = "";
        },
        (error) => {
          this.nao.go(100);
          toastr.error("Some thing went wrong");
        }
      );
  }

  openImgPopup(image) {
    this.imageForPopup = image;
    console.log("image", image);
    $("#openImgModal").modal("show");
  }

  closeModal() {
    $("#openImgModal").modal("hide");
  }

  clearSearch() {
    // this.pageOrder = 0;
    this.searchOrderString = "";
    this.orderTextDetailListing();
    // this.searchAllOrders();
  }

  filterFun(index, name) {
    this.paginationPage = 0;
    this.outletDayindex = index;
    this.outletDayname = name;
    this.orderTextDetailListing();
  }

  filterCityFun(index, name) {
    this.cityName = name;
    this.cityIndex = index;
    this.paginationPage = 0;
    this.orderTextDetailListing();
  }

  rejectFunc(status, id, index, phone_number) {
    this.rejectionText = "";
    this.statuschanger = status;
    this.textId = id;
    this.textIdIndex = index;
    this.phone_number = phone_number;
    $("#rejection").modal("show");
  }

  contactFunc(status, id, index, phone_number) {
    this.contactText = "";
    this.statuschanger = status;
    this.textId = id;
    this.textIdIndex = index;
    this.phone_number = phone_number;
    // this.sendContactFunc();
    $("#contact").modal("show");
  }

  sendContactFunc() {
    if (this.contactText === "") {
      // if(this.contactText === '' && this.orderDetail.order_text_status === 1){
      toastr.error("please add detail");
      return;
    }
    this.nao.go(30);
    this.dataService
      .sendContactsSupport(
        window.localStorage.getItem("token"),
        this.statuschanger,
        this.textId,
        this.contactText,
        this.phone_number
      )
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.changeStatus = data;
          this.changeStatus = this.changeStatus.success;
          if (this.changeStatus === true) {
            console.log("Working");
            this.orderDetail[this.textIdIndex].order_text_message_count++;
            var today = new Date();
            var obj = {
              contact_message: this.contactText,
              order_text_message_date: today,
              order_text_id: -1,
            };
            this.orderDetail[this.textIdIndex].order_text_contact_message.push(
              obj
            );
            toastr.success(data["message"]);
          }
          $("#contact").modal("hide");
        },
        (error) => {
          this.nao.go(100);
          toastr.error("Some thing went wrong");
        }
      );
  }

  messagesListingFunc(list) {
    // var today = new Date();
    // console.log('today', today);
    // var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
    // console.log('date' , date);
    this.messagesDetail = list;
    $("#listing").modal("show");
    console.log("this.messagesDetail", this.messagesDetail);
  }

  showCustomerDetails(dataid) {
    var scroll = $(window).scrollTop();
    var data = { id: dataid, page: "customerLis", scroll: scroll };
    this.events.publish("customerId", data);
    $(".customOrder").css("display", "none");
    setTimeout(() => {
      $(".customOrderCustomerDetail").css("display", "block");
    });
  }

  orderDetailCall(id) {
    this.orderDetailToReopenOpId = id;
    this.dataService
      .getOrderhDetail(window.localStorage.getItem("token"), id)
      .subscribe(
        (data) => {
          this.orderDetailData = data;

          console.log("orderdetailcall", this.orderDetailData);

          this.customerDetail = this.orderDetailData["customer_detail"];
          this.droppOffAddress = this.orderDetailData["dropoff_address"];
          this.userDropDocs = this.orderDetailData["drop_off_docs"];
          console.log("userDropDocs", this.userDropDocs);
          this.orderDataDisplay = this.orderDetailData["order"];
          this.pickupAddress = this.orderDetailData["pickup_address"];
          this.productData = this.orderDetailData["product"];
          this.thirdPartyData = this.orderDetailData["third_party"];
          this.onDetailDriverData = this.orderDetailData["driver"];
          this.returnOrderItems =
            this.orderDataDisplay.return_items["return_product_list"];
          this.returnOrderItemsLength = this.returnOrderItems.length;
          this.orderCreated = this.orderDetailData["order_created_by"];
          this.orderBooked = this.orderDetailData["order_booked_by"];
          console.log("orderCreated", this.orderCreated);
          // console.log('this.onDetailDriverData', this.onDetailDriverData);

          var cDate = new Date().getDate();
          var cYear = new Date().getFullYear();
          var cMonth = new Date().getUTCMonth() + 1;
          var openTime = this.orderDataDisplay.open_time;
          var tOpen =
            cYear + "/" + cMonth + "/" + cDate + " " + openTime + " " + "UTC";
          var dateObjOpen = new Date(tOpen);
          this.deliverStartDate = dateObjOpen;

          var closeTime = this.orderDataDisplay.close_time;
          var tClose =
            cYear + "/" + cMonth + "/" + cDate + " " + closeTime + " " + "UTC";
          var dateObjClose = new Date(tClose);
          this.deliverEndDate = dateObjClose;
          $("#orderDetailPop1").modal("show");
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  searchCustomerOnOrder() {
    clearTimeout(this.clearTimeoutCustomer);
    this.clearTimeoutCustomer = setTimeout(() => {
      this.nao.go(30);
      console.log("login data");
      this.dispensary_id = "";
      this.dataService
        .searchCustomers(
          window.localStorage.getItem("token"),
          this.searchStringCustomer,
          this.dispensary_id
        )
        .subscribe(
          (data) => {
            this.nao.go(100);
            console.log("products data", data);
            if (this.searchStringCustomer === "") {
              this.customerData = [];
            } else {
              this.customerData = data;
              this.customerData = this.customerData.items;
              this.customerDataLength = this.customerData.length;
              for (var i = 0; i < this.customerData.length; i++) {
                if (this.customerData[i].country_code === "+1") {
                  this.customerData[i].phone_number = format(
                    this.customerData[i].phone_number,
                    "US",
                    "NATIONAL"
                  );
                  console.log(
                    "this.driverData[i].number",
                    this.customerData[i].phone_number
                  );
                }
              }
            }
          },
          (error) => {
            this.nao.go(100);
            console.log("error", error);
          }
        );
    }, 1000);
  }

  selectCustomer(id) {
    this.customerDisplayDataArray = [];
    localStorage.setItem("client_id", id);
    for (var i = 0; i < this.customerDataLength; i++) {
      if (this.customerData[i].id === id) {
        this.selectedCustomerId = id;
        this.selectedCustomerObj = this.customerData[i];
        this.searchStringCustomer =
          this.selectedCustomerObj.country_code +
          "" +
          this.selectedCustomerObj.phone_number;
        console.log("address_list", this.selectedCustomerObj);
        this.freeCount = this.selectedCustomerObj.free_delivery_count;
        this.customerAddressList =
          this.selectedCustomerObj.address_list.address_dictionary;
        this.customerDisplayDataArray.push({
          id: this.selectedCustomerObj.id,
          first_name: this.selectedCustomerObj.first_name,
          last_name: this.selectedCustomerObj.last_name,
          payments: this.selectedCustomerObj.payments,
          email: this.selectedCustomerObj.email,
          country_code: this.selectedCustomerObj.country_code,
          phone_number: this.selectedCustomerObj.phone_number,
          address: "",
          street: "",
          city: "",
          state: "",
          area: "",
          zip: "",
          apart_no: "",
          longitude: 0,
          latitude: 0,
          is_default: false,
          place_label: "",
          address_id: null,
        });
        for (
          var j = 0;
          j < this.selectedCustomerObj.address_list.address_dictionary.length;
          j++
        ) {
          if (
            this.selectedCustomerObj.address_list.address_dictionary[j]
              .is_default === true
          ) {
            this.customerDisplayDataArray = [];
            this.customerDisplayDataArray.push({
              id: this.selectedCustomerObj.id,
              first_name: this.selectedCustomerObj.first_name,
              last_name: this.selectedCustomerObj.last_name,
              payments: this.selectedCustomerObj.payments,
              email: this.selectedCustomerObj.email,
              country_code: this.selectedCustomerObj.country_code,
              phone_number: this.selectedCustomerObj.phone_number,
              address:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .address_line1,
              street:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .address_line1,
              city: this.selectedCustomerObj.address_list.address_dictionary[j]
                .city,
              state:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .state,
              area: this.selectedCustomerObj.address_list.address_dictionary[j]
                .country,
              zip: this.selectedCustomerObj.address_list.address_dictionary[j]
                .zip,
              apart_no:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .apart_no,
              longitude:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .longitude,
              latitude:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .latitude,
              is_default:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .is_default,
              place_label:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .place_label,
              house_building_no:
                this.selectedCustomerObj.address_list.address_dictionary[j]
                  .house_building_no,
              address_id:
                this.selectedCustomerObj.address_list.address_dictionary[j].id,
            });
          }
        }
      }
    }
  }

  orderRequestBtn() {
    $("#orderRequestPop").modal("show");
  }

  openAddCustomerPop() {
    $(".c-label input").css("border-color", "#ccc");
    if (this.searchStringCustomer.length == 11) {
      this.searchStringCustomer = this.searchStringCustomer.substr(1);
      this.phoneCode = "+92";
    }
    if (this.searchStringCustomer.length >= 13) {
      this.phoneCode = this.searchStringCustomer.substr(0, 3);
      this.searchStringCustomer = this.searchStringCustomer.substr(3);
    }
    if (this.searchStringCustomer.length > 10) {
      this.numChk = true;
      $("#phoneValue").css("border-color", "#eb3b3b");
    }
    console.log($("#phone").val());
    this.customerMatch = false;
    $("#datepicker").val("");
    this.first_name = "";
    this.last_name = "";
    this.accept_marketing = false;
    this.is_tax_exempt = false;
    this.email = "";
    this.note = "";
    this.findCustomerData = "";
    this.number = this.searchStringCustomer;
    this.countryCode = this.phoneCode;
    this.address_line1 = "";
    this.address_line2 = "";
    this.city = "";
    this.state = "";
    this.street = "";
    this.zip = "";
    this.area = "";
    this.apart = "";
    $("#is_tax_exempt").prop("checked", false);
    $("#accept_marketing").prop("checked", false);
    this.findCustomer();
    $("#addCustomerPop").modal("show");
    $(".c-label label").css("color", "#3d3e3d");
    $(".uploadText").css("color", "#3d3e3d");
    $(".c-label textarea").css("border-color", "#ccc");
    this.selectAddress = false;
  }

  findCustomer() {
    this.nao.go(30);
    var getCode = $("#phone").intlTelInput("getSelectedCountryData").dialCode;
    var num = "+" + getCode + this.number;
    console.log("login data");
    this.dataService
      .showCustomerList(window.localStorage.getItem("token"), num)
      .subscribe(
        (data) => {
          this.nao.go(100);
          this.findCustomerData = data;
          if (this.findCustomerData.rest_error_code === 4) {
            this.customerMatch = false;
            $("#datepicker").val("");
            this.first_name = "";
            this.last_name = "";
            this.accept_marketing = false;
            this.is_tax_exempt = false;
            this.email = "";
            this.note = "";
            this.findCustomerData = "";
            this.address_line1 = "";
            this.address_line2 = "";
            this.city = "";
            this.state = "";
            this.zip = "";
            this.area = "";
            $("#is_tax_exempt").prop("checked", false);
            $("#accept_marketing").prop("checked", false);
            this.selectAddress = false;
            return;
          } else {
            this.dob = "";
            this.selDate = "";
            setTimeout(() => {
              this.dob = this.findCustomerData.date_of_birth;
              this.selDate = this.findCustomerData.date_of_birth;
              this.first_name = this.findCustomerData.first_name;
              this.last_name = this.findCustomerData.last_name;
              this.accept_marketing = this.findCustomerData.accept_marketing;
              this.is_tax_exempt = this.findCustomerData.tax_exempt;
              this.email = this.findCustomerData.email;
              this.note = this.findCustomerData.note;
              this.findCustomerData = this.findCustomerData.address;
              this.latitude = this.findCustomerData.latitude;
              this.longitude = this.findCustomerData.longitude;
              this.address_line1 = this.findCustomerData.address_line1;
              this.address_line2 = this.findCustomerData.address_line2;
              this.city = this.findCustomerData.city;
              this.state = this.findCustomerData.state;
              this.street = this.findCustomerData.street;
              this.zip = this.findCustomerData.zip;
              this.area = this.findCustomerData.area;
              this.apart = this.findCustomerData.apart_no;
              if (this.is_tax_exempt === true) {
                $("#is_tax_exempt").prop("checked", true);
              }
              if (this.accept_marketing === true) {
                $("#accept_marketing").prop("checked", true);
              }
              this.customerMatch = true;
              console.log("cutomer data get with phone#", data);
              if (
                this.findCustomerData.longitude !== null &&
                this.findCustomerData.longitude !== "" &&
                this.findCustomerData.latitude !== null &&
                this.findCustomerData.latitude !== "" &&
                this.findCustomerData.address_line1 !== null &&
                this.findCustomerData.address_line1 !== ""
              ) {
                this.selectAddress = true;
                this.callMap();
              } else {
                this.selectAddress = false;
              }
            }, 1000);
          }
        },
        (error) => {
          this.nao.go(100);
          console.log("error", error);
        }
      );
  }

  callMap() {
    setTimeout(() => {
      $("#myMapDiv").css("display", "block");
      var context = this;
      var map;
      var marker;
      var adr;
      var myLatlng = new google.maps.LatLng(this.latitude, this.longitude);
      var geocoder = new google.maps.Geocoder();
      var infowindow = new google.maps.InfoWindow();
      var mapOptions = {
        zoom: 20,
        center: myLatlng,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        navigationControl: false,
      };
      var endImage = {
        url: "assets/pin.png", // url
        scaledSize: new google.maps.Size(20, 32), // scaled size
        origin: new google.maps.Point(0, 0), // origin
        anchor: new google.maps.Point(10, 35), // anchor
      };
      map = new google.maps.Map(document.getElementById("myMap"), mapOptions);
      marker = new google.maps.Marker({
        map: map,
        position: myLatlng,
        draggable: true,
        icon: endImage,
      });
      geocoder.geocode({ latLng: myLatlng }, function (results, status) {
        if (status === google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            infowindow.setContent(results[0].formatted_address);
            infowindow.open(map, marker);
            context.latitude = marker.getPosition().lat();
            context.longitude = marker.getPosition().lng();
            console.log(context.latitude, context.longitude);
            console.log("results", results);
          }
        }
      });

      google.maps.event.addListener(marker, "dragend", function () {
        geocoder.geocode(
          { latLng: marker.getPosition() },
          function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
              if (results[0]) {
                infowindow.setContent(results[0].formatted_address);
                infowindow.open(map, marker);
                context.latitude = marker.getPosition().lat();
                context.longitude = marker.getPosition().lng();
                console.log(context.latitude, context.longitude);
                console.log("results", results);
              }
            }
          }
        );
      });
    }, 10);
  }

  functionTogetPlace() {
    if (this.selectAddress === true) {
      return;
    }
    this.placeDataFound = false;
    this.placeSuggestionsData = [];
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.dataService.googleAddress(this.address_line1).subscribe(
        (data) => {
          this.placeSuggestionsData = data;
          this.placeSuggestionsData = this.placeSuggestionsData.predictions;
          this.placeDataFound = true;
          if ($(".myDrop").hasClass("open")) {
          } else {
            $(".myDrop").addClass("open");
          }
        },
        (error) => {}
      );
    }, 1000);
  }

  resetAddress() {
    this.address_line1 = "";
    this.city = "";
    this.state = "";
    this.zip = "";
    this.area = "";
    this.houseNo = "";
    this.apart = "";
    this.longitude = "";
    this.latitude = "";
    this.selectAddress = false;
  }

  functionTogetPlaceDetail(name, id) {
    this.addressLoad = true;
    this.address_line1 = name;
    clearTimeout(this.clearTimeout);
    this.clearTimeout = setTimeout(() => {
      this.dataService.googleAddressDetail(id).subscribe(
        (data) => {
          this.placeDetailData = data;
          this.selectAddress = true;
          this.placeDetailData = this.placeDetailData.result;
          this.latitude = this.placeDetailData.geometry.location.lat;
          this.longitude = this.placeDetailData.geometry.location.lng;
          this.placeDetailData = this.placeDetailData.address_components;
          setTimeout(() => {
            this.callMap();
            this.addressDetailAddCustomer();
            this.addressLoad = false;
          }, 1000);
        },
        (error) => {}
      );
    }, 1000);
  }

  addressDetailAddCustomer() {
    this.street = "";
    console.log("chk address detail", this.place);
    for (var i = 0; i < this.placeDetailData.length; i++) {
      for (var j = 0; j < this.placeDetailData[i].types.length; j++) {
        if (this.placeDetailData[i].types[j] === "locality") {
          $("#city").val(this.placeDetailData[i].long_name);
        }
        if (this.placeDetailData[i].types[j] === "street_number") {
          this.street = this.placeDetailData[i].long_name;
          console.log("street number", this.street);
        }
        if (this.placeDetailData[i].types[j] === "route") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          console.log("route", this.street);
        }
        if (this.placeDetailData[i].types[j] === "sublocality_level_2") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          console.log("sublocality 2", this.street);
        }
        if (this.placeDetailData[i].types[j] === "sublocality_level_1") {
          this.street = this.street + " " + this.placeDetailData[i].long_name;
          console.log("sublocality 1", this.street);
        }

        if (
          this.placeDetailData[i].types[j] === "administrative_area_level_1"
        ) {
          $("#state").val(this.placeDetailData[i].short_name);
        }

        if (this.placeDetailData[i].types[j] === "country") {
          $("#area").val(this.placeDetailData[i].long_name);
        }

        if (this.placeDetailData[i].types[j] === "postal_code") {
          console.log("postal; code", this.placeDetailData[i].long_name);
          $("#zip").val(this.placeDetailData[i].long_name);
        } else {
          $("#zip").val("");
        }
      }
    }
  }

  addCutomerFunction() {
    this.error_count = 0;
    $(".c-label label").css("color", "#3d3e3d");
    $(".uploadText").css("color", "#3d3e3d");
    $(".c-label input").css("border-color", "#ccc");
    $(".c-label textarea").css("border-color", "#ccc");
    this.addingCustomer = true;
    if ($("#is_tax_exempt").is(":checked")) {
      this.is_tax_exempt = true;
    }
    if ($("#accept_marketing").is(":checked")) {
      this.accept_marketing = true;
    }
    // this.address_line1 = $('#searchTextFieldAddAddress').val();
    this.address_line1 = "";
    // this.city = $('#city').val();
    // this.zip = $('#zip').val();
    // this.houseNo = $('#houseNo').val();
    // this.state = $('#state').val();
    // this.area = $('#area').val();
    // this.apart = $('#apart').val();
    this.city = "";
    this.zip = "";
    this.houseNo = "";
    this.state = "";
    this.area = "";
    this.apart = "";
    if (this.dob != "" && this.dob != undefined) {
      var formatedDob = this.dob.formatted;
    }
    // this.address_line1 = $('#searchTextFieldAddAddress').val();
    console.log("login data", this.address_line1);
    if (this.first_name === "" || this.first_name === undefined) {
      $("#c-fname label").css("color", "#a10a0d");
      $("#c-fname input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.last_name === "" || this.last_name === undefined) {
      $("#c-lname label").css("color", "#a10a0d");
      $("#c-lname input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (
      this.number === "" ||
      this.number === undefined ||
      this.numChk === true
    ) {
      $("#c-phone label").css("color", "#a10a0d");
      $("#c-phone input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    // if (this.address_line1 === '' || this.address_line1 === undefined) {
    //   $('#c-address label').css('color', '#a10a0d');
    //   $('#c-address input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.city === '' || this.city === undefined) {
    //   $('#c-city label').css('color', '#a10a0d');
    //   $('#c-city input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.zip === '' || this.zip === undefined) {
    //   $('#c-zip label').css('color', '#a10a0d');
    //   $('#c-zip input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.state === '' || this.state === undefined) {
    //   $('#c-state label').css('color', '#a10a0d');
    //   $('#c-state input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    // if (this.area === '' || this.area === undefined) {
    //   $('#c-area label').css('color', '#a10a0d');
    //   $('#c-area input').css('border-color', '#a10a0d');
    //   this.error_count ++;
    // }
    if (this.gender === "" || this.gender === -1) {
      $("#c-gender label").css("color", "#a10a0d");
      $("#c-gender input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.dob === "" || this.dob === undefined) {
      $("#c-dob label").css("color", "#a10a0d");
      $("#c-dob input").css("border-color", "#a10a0d");
      this.error_count++;
    }
    if (this.error_count > 0) {
      return;
    }
    // if (this.latitude === undefined || this.latitude === '' || this.longitude === undefined || this.longitude === '') {
    //   toastr.error('Please Update the address & select it from Google suggestions for accuracy');
    //   return;
    // }
    this.latitude = null;
    this.longitude = null;
    // var getCode = $('#phone').intlTelInput('getSelectedCountryData').dialCode;
    var number = this.phoneCode + this.number;
    console.log("number", this.number);
    this.nao.go(30);
    this.btnDisable = true;
    this.street = this.address_line1;
    this.dataService
      .addCustomer(
        window.localStorage.getItem("token"),
        this.first_name,
        this.last_name,
        number,
        this.email,
        (this.is_tax_exempt = false),
        (this.accept_marketing = false),
        this.address_line1,
        this.street,
        this.address_line2,
        this.city,
        this.state,
        this.zip,
        this.area,
        this.apart,
        this.note,
        formatedDob,
        this.latitude,
        this.longitude,
        this.houseNo,
        this.gender,
        this.dispensary_id
      )
      .subscribe(
        (data) => {
          console.log("outlet data");
          this.nao.go(100);
          this.success = data;
          this.restErrorCode = data;
          this.restErrorCode = this.restErrorCode.rest_error_code;
          if (this.restErrorCode === 1) {
            toastr.error("Some thing went wrong");
            this.btnDisable = false;
          }
          if (this.restErrorCode === 2) {
            toastr.error("Please login again");
            this.btnDisable = false;
          }
          if (this.restErrorCode === 3) {
            toastr.error("Customer already exists");
            this.btnDisable = false;
          }
          if (this.restErrorCode === 4) {
            toastr.error("Customer does not exist");
            this.btnDisable = false;
          }
          if (this.success.success === true) {
            this.btnDisable = false;
            $("#addCustomerPop").modal("hide");
            var numberid = this.success.customer_id;
            console.log("in success of add customer", numberid, this.success);
          }
          if (this.success.success === false) {
            this.addingCustomer = false;
            this.btnDisable = false;
          }
        },
        (error) => {
          this.nao.go(100);
          this.addingCustomer = false;
          this.btnDisable = false;
          console.log("error", error);
        }
      );
  }
  messageSubscription: Subscription;
  ngOnInit() {
    $(".customOrderCustomerDetail").css("display", "none");
    // this.sendContactFunc();
    this.orderTextDetailListing();
    $(".clearSideSelecteion").css("color", "#3d3d3d");
    $("#orderDetail").css("color", "#d77229");
    $(() => {
      $("#phone").intlTelInput({
        // autoFormat: true,
        utilsScript:
          "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/12.1.9/js/utils.jss",
        autoPlaceholder: false,
        allowDropdown: true,
        preferredCountries: ["GB"],
        preventInvalidNumbers: true,
        // stop the user from typing invalid dial codes
        preventInvalidDialCodes: true,
        formatOnDisplay: true,
        separateDialCode: false,
      });
      this.maxYear = new Date().getFullYear();
      this.maxYear = parseInt(this.maxYear) - 21;
      $("#datepicker").datepicker({
        format: "mm/dd/yyyy", // Notice the Extra space at the beginning,
        defaultDate: "-10d",
        endDate: new Date("12/31/" + this.maxYear),
      });
      var countryCode;
      setTimeout(() => {
        console.log($("#phone").intlTelInput("getSelectedCountryData"));
        countryCode = $("#phone").intlTelInput(
          "getSelectedCountryData"
        ).dialCode;
        $("#phone").val("+" + countryCode);
        this.phoneCode = $("#phone").val();
      }, 1000);
      $("#phone").change(function () {
        countryCode = $("#phone").intlTelInput(
          "getSelectedCountryData"
        ).dialCode;
        $("#phone").val("+" + countryCode);
        this.phoneCode = $("#phone").val();
      });
    });

    this.searchSpecificBusiness();
  }

  ngAfterViewInit(): void {
    this.authService.currentMessage.subscribe((value: any) => {
      console.log("list refresh order req:", value);
      if (value != null) {
        if (this.checkPopupOpenFlag == true) {
          this.orderTextDetailListing();
        } else {
          return;
        }
      } else {
        return;
      }
    });
  }

  changeCountryCode() {
    console.log("country code is changed");
  }

  searchSpecificBusiness() {
    clearTimeout(this.searchTimeOut);
    this.searchTimeOut = setTimeout(() => {
      this.dataService
        .getdispensaryListingById(
          localStorage.getItem("token"),
          "",
          this.searchBusiness
        )
        .subscribe(
          (data) => {
            this.showSearchResults = true;
            this.searchBusinessDetailforOrder = data;
          },
          (error) => {
            console.log("error", error);
            toastr.error("Some thing went wrong");
          }
        );
    });
  }

  openOrderRequestPopup() {
    const Dropzone = require("dropzone");
    const context = this;
    try {
      new Dropzone("#my-awesome-dropzone", {
        maxFiles: 10,
        addRemoveLinks: true,
        dictDefaultMessage: "Upload Images",
        autoProcessQueue: false,
        paramName: "image",
        acceptedMimeTypes: "image/jpeg, image/jpg, image/png",
        progress: false,
        init: function () {
          context.dropzone = this;

          this.on("addedfile", function (file) {
            if (!file.type.match(/image.*/)) {
              // This is not an image, so Dropzone doesn't create a thumbnail.
              // Set a default thumbnail:
              // this.emit('thumbnail', file, '../app/assets/images/interface.png');
              // You could of course generate another image yourself here,
              // and set it as a data url.
            }
            context.customProductImages.push(file);
          });

          this.on("error", function (file, response) {
            // $(file.previewElement).find('.dz-error-message').text(response.file_name);
            // context.error_count++;
          });

          this.on("queuecomplete", function () {});

          this.on("removedfile", function (file) {
            for (var i = 0; i < context.customProductImages.length; i++) {
              if (context.customProductImages[i].name === file.name) {
                context.customProductImages.splice(i, 1);
              }
            }
          });

          this.on("processing", function () {
            this.options.autoProcessQueue = false;
          });

          context.dropzone = this;
        },
      });
    } catch (err) {}
  }

  filterBusinessId(id, name, detail) {
    this.dispensary_id = id;

    if (this.dispensary_id == -1) {
      this.businessForOrders = "All Businesses";
    }

    if (this.dispensary_id != -1) {
      this.businessForOrders = name;
    }
  }
  createOrder(id, name) {
    this.businessIdForOrders = id;
    this.businessForOrders = name;
  }

  orderRequests() {
    if (this.orderText === "" && this.customProductImages.length === 0) {
      toastr.error("Please add text or upload image");
      return;
    }

    this.customProductImagesCount = 0;
    this.customOrderImageSuccessUrl = new Array();

    this.orderbtn = true;
    if (this.customProductImages.length > 0) {
      var file = this.customProductImages[0];
      this.uploadOrderImage(file);
      this.orderTextDetailListing();
    } else {
      this.uploadOrderText();
      this.orderTextDetailListing();
    }
  }

  uploadOrderImage(file) {
    let data = {
      auth_token: localStorage.getItem("token"),
      order_text: this.orderText,
      images_list: file,
      address: this.orderRequestAddress,
      city: this.orderRequestCity,
      user_id: this.selectedCustomerId,
      social_platform: this.orderRequestPlatform,
      dispensary_id: this.businessIdForOrders,
    };

    this.dataService.orderRequestImage(data).subscribe(
      (data) => {
        this.customOrderImageSuccess = data;
        if ((this.customOrderImageSuccess.success = true)) {
          this.customOrderImageSuccessUrl.push(
            this.customOrderImageSuccess.url
          );
          this.customProductImagesCount++;
          if (this.customProductImages.length > this.customProductImagesCount) {
            var file = this.customProductImages[this.customProductImagesCount];
            this.uploadOrderImage(file);
            this.orderTextDetailListing();
          } else {
            this.uploadOrderText();
            this.orderTextDetailListing();
          }
        } else {
          this.orderbtn = false;
          toastr.error("Something went wrong");
        }
      },
      (error) => {}
    );
  }

  customOrderSuccess: any;

  uploadOrderText() {
    let data = {
      auth_token: localStorage.getItem("token"),
      images_list: this.customOrderImageSuccessUrl,
      order_text: this.orderText,
      address: this.orderRequestAddress,
      city: this.orderRequestCity,
      user_id: this.selectedCustomerId,
      social_platform: this.orderRequestPlatform,
      dispensary_id: this.businessIdForOrders,
    };

    this.dataService.orderRequest(data).subscribe(
      (data) => {
        this.customOrderSuccess = data;
        if (this.customOrderSuccess.success === true) {
          toastr.success(
            "Your request has been successfuly sent. Our team will contact you soon."
          );
          $("#customOrderPopup").modal("hide");
          this.orderbtn = false;
          this.customOrderImageSuccessUrl = new Array();
          this.customProductImages = new Array();
          this.orderTextDetailListing();
        }
      },
      (error) => {}
    );
  }

  checkBtnCondition() {
    let customer = (<HTMLInputElement>document.getElementById("cText")).value;

    let address = (<HTMLInputElement>(
      document.getElementById("orderRequestAddress")
    )).value;
    let city = (<HTMLInputElement>document.getElementById("orderRequestCity"))
      .value;
    let platform = (<HTMLInputElement>(
      document.getElementById("orderRequestPlatform")
    )).value;
    let business = (<HTMLInputElement>document.getElementById("bussinessId"))
      .value;
    let text = (<HTMLInputElement>document.getElementById("orderText")).value;
    // let image = (<HTMLInputElement>document.getElementById('imageId')).value;

    if (
      customer != "" &&
      address != "" &&
      city != "" &&
      platform != "" &&
      business != "" &&
      (text != "" || this.customProductImages.length > 0)
    ) {
      this.orderbtn = true;
    } else {
      this.orderbtn = false;
    }
  }
  selectGender(val) {
    if (this.gender != val) {
      // this.showGender = true;
    }
    this.gender = val;
  }

  countryValidation() {
    var code = $("#phone").intlTelInput("getSelectedCountryData").dialCode;
    code = "+" + code;
    var val = $("#phoneValue").val();
    for (var i = 0; i < this.cs.country.length; i++) {
      if (code === this.cs.country[i].countryCode) {
        // // console.log('val.length', val.length, this.cs.country[i].length);
        if (val.length === this.cs.country[i].length) {
          // console.log('valid');
          this.numChk = false;
          $("#phoneValue").css("border-color", "#ccc");
        } else {
          // console.log('invalid');
          this.numChk = true;
          $("#phoneValue").css("border-color", "#eb3b3b");
        }
      }
    }
  }
  restrictUserInput($event) {
    console.log($event.target.value);
    // $event.preventDefault();
  }

  prevent(event) {
    // $event.preventDefault();
  }

  checkFields() {
    if (this.customOrderId !== "" && this.purchase_amount !== "") {
      this.orderPunched = true;
    } else {
      this.orderPunched = false;
    }
  }

  //added by zeeshan
  driverDetails(driver_id) {}

  //get Message listing
  openMessagePopup(data, index) {
    data.unread_messages_count = 0;
    this.checkPopupOpenFlag = false;
    const modalRef = this.modalService.open(ChatModalComponent, {
      centered: true,
      windowClass: "in",
      backdropClass: "in",
      backdrop: "static",
    });
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.order = 1;
    modalRef.componentInstance.modalClose.subscribe((receivedEntry) => {
      this.checkPopupOpenFlag = receivedEntry;
      console.log(receivedEntry);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/custom-order/custom-order.component.ts